import { CircularProgress, Stack, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { PaymentMethodTablePropsType } from "../../../types/container.type";
import DeleteIcon from '@mui/icons-material/Delete';
import { BaseButton } from "../../../components/button/styled";
import { formatDate } from "../../../helpers/dateFormatter";

export const PaymentMethodTable: React.FC<PaymentMethodTablePropsType> = ({ rows, handleItemClick, selectedPaymentMethodId }) => {
    const paymentMethodTableHeaders = ["Name", "Payment Method", "GL Account", "Status", "Date", "Action"];
    return (
        <BaseTable
            headers={paymentMethodTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow
                            key={index}
                        >
                            <TableCell>{row?.name?.charAt(0).toUpperCase() + row?.name?.slice(1)}</TableCell>
                            <TableCell>{row?.method?.charAt(0).toUpperCase() + row?.method?.slice(1)}</TableCell>
                            <TableCell>{row?.glAccount?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}</TableCell>
                            <TableCell>{formatDate(row?.createdAt, false)}</TableCell>
                            <TableCell>
                                <Stack
                                    direction={"row"}
                                    gap={"calc(var(--flex-gap)/4)"}
                                >
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, row.id, "edit")}
                                    >
                                        <Typography
                                            variant={"button"}
                                            fontFamily={"inherit"}
                                            fontWeight={"inherit"}
                                            fontSize={"inherit"}
                                            lineHeight={"inherit"}
                                            color={"inherit"}
                                            textTransform={"inherit"}
                                        >
                                            Edit
                                        </Typography>
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, { paymentMethodId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {(selectedPaymentMethodId !== null && selectedPaymentMethodId === row.id) ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}